import {
  createHabitat,
  CreateHabitatMutation,
  CreateHabitatMutationVariables,
  deleteHabitat,
  DeleteHabitatMutation,
  DeleteHabitatMutationVariables,
  graphqlCall,
  updateHabitat,
  UpdateHabitatMutation,
  UpdateHabitatMutationVariables,
} from '@akin-home/amplify';

export const updateHabitatMutation = (params: UpdateHabitatMutationVariables) =>
  graphqlCall<UpdateHabitatMutation>(updateHabitat, params);

export const createHabitatMutation = (params: CreateHabitatMutationVariables) =>
  graphqlCall<CreateHabitatMutation>(createHabitat, params);

export const deleteHabitatMutation = (params: DeleteHabitatMutationVariables) =>
  graphqlCall<DeleteHabitatMutation>(deleteHabitat, params);
